import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, zipRegex } from "constants/validations";

// Zip Code Schema
export const zipCodeSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .regex(zipRegex, { message: "Must be 5 digits" });

export const optionalZipCodeSchema = z.union([z.literal(""), zipCodeSchema]).optional();
